import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import CustomizedProgressBar from "../../Components/LinearDeterminate";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import AllRecentConsultation from "./AllRecentConsultation";
import AllPreferredDoctor from "./AllPreferredDoctor";
import BranchSelector from "./BranchSelector";
import Button from "../../Components/Button";
import { Fragment } from "react";
import "./style.css";

const StepTwo = () => {
  const {
    getSpecialization,
    setDisplayAlert,
    selectedClinic,
    previewScreen,
    handleBack,
    navigate,
  } = useConsultDoctorContext();

  const stepTwoValidation = selectedClinic !== undefined;

  function handleNext() {
    if (stepTwoValidation) {
      navigate("/consult-doctor/choose-date-time");
      getSpecialization();
    } else setDisplayAlert(true);
  }

  let content = null;
  if (previewScreen === "prefDocs") {
    content = <AllPreferredDoctor />;
  } else if (previewScreen === "recentConsult") {
    content = <AllRecentConsultation />;
  } else {
    content = (
      <Fragment>
        <div className="w-full">
          <div className="flex flex-row p-3">
            <KeyboardArrowLeft
              className="cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-center text-md font-bold flex-1">
              Consult a doctor
            </div>
            <CloseOutlined
              className=" cursor-pointer"
              onClick={() => setDisplayAlert(true)}
            />
          </div>
          <div className="p-3">
            <CustomizedProgressBar value={50} />
          </div>
        </div>

        <div className="w-full px-3">
          <div className="text-sm text-[#60656D]">
            Find Primary Care Clinics or cities near you
          </div>
          <BranchSelector />
        </div>

        <div className="flex w-full p-4 mt-auto sm:justify-end">
          <Button
            disabled={!stepTwoValidation}
            className={`h-14 w-full sm:w-22.5 ${
              !stepTwoValidation ? "bg-[#F6F7F7]" : "bg-[#0053CC]"
            } rounded-xl`}
            onClick={handleNext}
          >
            <p
              className={`font-medium font-sans text-xs ${
                !stepTwoValidation ? "text-[#A3A7AB]" : "text-white"
              }`}
            >
              Continue
            </p>
          </Button>
        </div>
      </Fragment>
    );
  }

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        {content}
      </div>
    </div>
  );
};

export default StepTwo;
